export default __webpack_public_path__ + "static/media/car-electric.739acf4c.svg";